import React, { useState, useMemo } from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import AppTableContainer from "@crema/core/AppTableContainer";
import TableHeading from "./TableHeading";
import TableItem from "./TableItem";
import { ContactMasterData } from "types/models/contactMaster/ContactMasterApp";

interface ContactTableProps {
  contact: ContactMasterData[];
}

const ContactTable: React.FC<ContactTableProps> = ({ contact }) => {
  const [order, setOrder] = useState<"asc" | "desc">("asc");
  const [orderBy, setOrderBy] = useState<keyof ContactMasterData>("name");

  const handleSort = (property: keyof ContactMasterData) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedContacts = useMemo(() => {
    return [...contact].sort((a, b) => {
      const aValue = a[orderBy];
      const bValue = b[orderBy];

      if (aValue == null || bValue == null) return 0;

      if (typeof aValue === "string" && typeof bValue === "string") {
        return aValue.localeCompare(bValue) * (order === "asc" ? 1 : -1);
      }

      if (typeof aValue === "number" && typeof bValue === "number") {
        return (aValue - bValue) * (order === "asc" ? 1 : -1);
      }

      return 0;
    });
  }, [contact, order, orderBy]);

  return (
    <AppTableContainer>
      <Table stickyHeader className="table">
        <TableHead>
          <TableHeading order={order} orderBy={orderBy} onSort={handleSort} />
        </TableHead>
        <TableBody>
          {sortedContacts.map((data) => (
            <TableItem data={data} key={data.id} />
          ))}
        </TableBody>
      </Table>
    </AppTableContainer>
  );
};

export default ContactTable;
